import { Component } from "preact";
import { connectWithTranslations } from "../../common/helpers/translationsHelpers";
import IconInfoCircle from "../../common/components/icons/IconInfoCircle";
import { CALENDAR_VIEW } from "../../calendar-common/constants";
import { GTM_ID, GA4EVENT} from "../constants";

const getGTMTracking = (view) => {
    switch (view) {
        case CALENDAR_VIEW.Configure_View_Basic:
            return GTM_ID.HEADER_BASIC_VIEW;
        case CALENDAR_VIEW.Configure_View_Default:
            return GTM_ID.HEADER_DEFAULT_VIEW;
        case CALENDAR_VIEW.Configure_View_Premium:
            return GTM_ID.HEADER_PREMIUM_VIEW;
    }
};
const getGA4TrackingElements = (view) => {
    switch (view) {
        case CALENDAR_VIEW.Configure_View_Basic:
            return GA4EVENT.ELEMENTS.HEADER_BASIC_VIEW;
        case CALENDAR_VIEW.Configure_View_Default:
            return GA4EVENT.ELEMENTS.HEADER_DEFAULT_VIEW;
        case CALENDAR_VIEW.Configure_View_Premium:
            return GA4EVENT.ELEMENTS.HEADER_PREMIUM_VIEW;
    }
};

class EventListHeaderDesktop extends Component {
    render({ translate, settings: { view }, config }) {
        return (
            <thead class="fxs_c_header">
                <tr 
                data-gtmid={config.tracking && getGTMTracking(view)}
                data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                data-ga4event-element={config.tracking && getGA4TrackingElements(view)}
                >
                    <th class="fxs_c_item ">{translate("HeaderTime")}</th>
                    <th class="fxs_c_item fxs_c_item_event_name" colspan="3">
                        {translate("HeaderEvent")}
                    </th>
                    <th class="fxs_c_item ">{translate("HeaderImpact")}</th>
                    <th class="fxs_c_item ">{translate("HeaderActual")}</th>
                    {view != CALENDAR_VIEW.Configure_View_Basic && (
                        <th class="fxs_c_item ">
                            {translate("HeaderDeviation")}
                            <span class="fxs_c_has-tooltip">
                                <span class="fxs_c_tooltip">
                                    <IconInfoCircle />
                                    <span class="fxs_c_content">
                                        <span class="fxs_c_textnode">
                                            {translate(
                                                "HeaderDeviationTooltip"
                                            )}
                                        </span>
                                    </span>
                                </span>
                            </span>
                        </th>
                    )}
                    <th class="fxs_c_item ">{translate("HeaderConsensus")}</th>
                    <th class="fxs_c_item ">{translate("HeaderPrevious")}</th>
                    <th class="fxs_c_item "></th>
                    <th class="fxs_c_item "></th>
                </tr>
            </thead>
        );
    }
}

export default connectWithTranslations("settings,config")(
    EventListHeaderDesktop
);
